import { TimerObserver } from '../../libs/timerObserver';
import { timerKeys } from '../../shared/constants';
import { getLogger } from '../../libs/logger';

export enum WaitingRoomStep {
  WaitingRoomLoading = 'waitingRoomLoading',
  WaitingRoomEntered = 'waitingRoomEntered',
  WaitingRoomRemoved = 'waitingRoomRemoved',
  WaitingRoomLeft = 'waitingRoomLeft',
  WaitingRoomRedirectToCall = 'waitingRoomRedirectToCall',
}

const logger = getLogger('waitingRoomTimer');

export const waitingRoomTimer = new TimerObserver<WaitingRoomStep>(
  timerKeys.waitingRoom,
  logger,
);
